export const checkHasIntegration = ((integrations, requiredIntegration) => (
  integrations.some((integration) => (
    integration.key === requiredIntegration))
));

export const checkHasIntegrationCategory = ((integrations, requiredIntegrationCategory) => (
  integrations.some((integration) => (
    integration.category === requiredIntegrationCategory))
));
